<script setup lang="ts">
import {computed, inject, ref} from 'vue'
import {Dropdown as VDropdown} from 'floating-vue'
import {assistantChatMessageContextKey} from '@/components/assistant/chat/messageContext'

const messageContext = inject(assistantChatMessageContextKey)

const props = defineProps<{
  isLastMessage?: boolean
  label: string
  messageId: number
  toggleKey: string
}>()

const visible = computed(
  () => messageContext?.getOrInitToggleVisible(props.messageId, props.toggleKey, !!props.isLastMessage) ?? !!props.isLastMessage
)
const visibleMenu = ref(false)

function toggleVisible() {
  messageContext?.setToggleVisible(props.messageId, props.toggleKey, !visible.value)
}
</script>

<template>
  <div class="flex flex-col gap-1 rounded-md px-2 py-1">
    <div class="flex flex-row items-center pr-1 print:hidden">
      <template v-if="visible">
        <button class="text-xs text-new-neutral-400 hover:text-new-primary-default" type="button" @click="toggleVisible">
          <i class="fa-solid" :class="visible ? 'fa-angle-up' : 'fa-angle-down'"></i>
          <span class="ml-1">{{ $t('assistant.chat.message.toggle.hide', {label}) }}</span>
        </button>

        <VDropdown
          v-if="$slots['download-menu']"
          v-model:shown="visibleMenu"
          auto-hide
          class="ml-auto"
          :show-triggers="['click', 'touch']"
        >
          <button>
            <i class="fa-solid fa-arrow-right-to-bracket rotate-90 text-new-neutral-400 hover:text-new-primary-default"></i>
          </button>

          <template #popper>
            <slot name="download-menu" />
          </template>
        </VDropdown>
      </template>
      <template v-else>
        <button class="text-xs text-new-neutral-400 hover:text-new-primary-default" type="button" @click="toggleVisible">
          <i class="fa-solid" :class="visible ? 'fa-angle-up' : 'fa-angle-down'"></i>
          <span class="ml-1">{{ $t('assistant.chat.message.toggle.show', {label}) }}</span>
        </button>
      </template>
    </div>
    <slot v-if="visible" />
  </div>
</template>
